import { memo, useEffect, useRef } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { log } from "react-better-html";
import { usePostHog } from "@posthog/react";

import { disablePostHog } from "../../constants/app";

import { useReduxAction } from "../../utils/hooks";
import { auth } from "../../utils/firebase";

function FirebaseAuth() {
   const posthog = usePostHog();

   const loadedUserRef = useRef<boolean>(false);

   const setFirebaseUser = useReduxAction((actions) => actions.user.setFirebaseUser);
   const setFirebaseUserIdToken = useReduxAction((actions) => actions.user.setFirebaseUserIdToken);
   const loadUser = useReduxAction((actions) => actions.user.loadUser);

   useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
         if (user) {
            const idToken = await user.getIdToken();
            setFirebaseUserIdToken(idToken);
         }

         setFirebaseUser(user ?? undefined);
         log.success("Firebase user loaded");

         if (!loadedUserRef.current) {
            loadUser();
            log.success("User loaded");
            loadedUserRef.current = true;

            if (!disablePostHog && posthog) {
               if (user) {
                  posthog.identify(user.uid, {
                     email: user.email,
                     name: user.displayName,
                  });

                  log.success("Posthog user identified");
               } else {
                  posthog.reset();
                  log.success("Posthog user reset");
               }
            }
         }
      });

      return () => {
         unsubscribe();
      };
   }, []);

   return <></>;
}

export default memo(FirebaseAuth);
